export function isBrandURL() {
  // For Prod
  const origin = window.location.origin;

  const ExcludeOnPremURLS = [
    'https://dashboard.hyperexecute.cloud',
    'https://stage-dashboard.hyperexecute.cloud',
  ];

  if (ExcludeOnPremURLS.includes(origin)) {
    return false;
  }

  let domainParts = origin.split('.');

  if (!isStageURL()) {
    return domainParts[1] !== 'lambdatest';
  }

  // For Stage

  return domainParts[1] !== 'lambdatestinternal';
}

function isStageURL() {
  const origin = window.location.origin;

  if (origin.includes('//stage')) {
    return true;
  }

  return false;
}

function getBrandName() {
  const origin = window.location.origin;
  let domainParts = origin.split('.');

  return domainParts[1];
}

export function getBrandURL(url) {
  const domainParts = url.split('.');

  const brandName = getBrandName();

  domainParts.splice(1, 0, brandName);
  return domainParts.join('.');
}
